export function getEditFormConfig() {
	return {
		FormData: [
			{
				el: "el-input",
				label: "订阅名称",
				name: "name",
				attrs: {
					placeholder: "请输入订阅名称",
				},
			},
			{
				el: "el-input-number",
				label: "首付价格（$）",
				name: "trialPrice",
				attrs: {
					placeholder: "请输入首付价格",
					precision: 2,
					step: 0.1,
					min: 0,
				},
			},
			{
				el: "el-input-number",
				label: "首次支付金额（$）",
				name: "firstSplitPaymentAmount",
				attrs: {
					placeholder: "请输入首次支付金额",
					precision: 2,
					step: 0.1,
					min: 0,
				},
			},
			{
				el: "el-input-number",
				label: "试用期天数",
				name: "trialDays",
				attrs: {
					placeholder: "请输入试用期天数",
					step: 1,
					min: 1,
				},
			},
			{
				el: "el-radio-group",
				name: "billingInterval",
				label: "循环单位",
				options: [
					{
						label: "天（DAY）",
						value: "DAY",
					},
					{
						label: "周（WEEK）",
						value: "WEEK",
					},
					{
						label: "月（MONTH）",
						value: "MONTH",
					},
				],
			},
			{
				el: "el-input-number",
				label: "间隔数",
				name: "intervalCount",
				attrs: {
					placeholder: "请输入间隔数",
					step: 1,
					min: 1,
				},
			},
			{
				el: "el-input-number",
				label: "循环扣费（$）",
				name: "totalCycles",
				attrs: {
					placeholder: "请输入循环扣费(0表示无限循环)",
					step: 1,
					min: 0,
				},
			},
			{
				el: "el-input-number",
				label: "周期循环扣费",
				name: "price",
				attrs: {
					placeholder: "请输入周期循环扣费",
					precision: 2,
					step: 0.1,
					min: 0,
				},
			},
			{
				el: "el-input-number",
				label: "总共费用（$）",
				name: "totalPrice",
				attrs: {
					placeholder: "请输入总共费用",
					precision: 2,
					step: 0.1,
					min: 0,
				},
			},

			{
				el: "el-radio-group",
				name: "isRecommend",
				label: "是否高级订阅",
				options: [
					{
						label: "是",
						value: 1,
					},
					{
						label: "否",
						value: 0,
					},
				],
			},

			{
				el: "el-radio-group",
				name: "isTrial",
				label: "是否试用包",
				options: [
					{
						label: "是",
						value: 1,
					},
					{
						label: "否",
						value: 0,
					},
				],
			},
		],
		rules: {
			name: [
				{
					required: true,
					message: "请输入订阅名称",
					trigger: "blur",
				},
			],
			trialPrice: [
				{
					required: true,
					message: "请输入首付价格",
					trigger: "blur",
				},
			],
			trialDays: [
				{
					required: true,
					message: "请输入试用期天数",
					trigger: "blur",
				},
			],
			billingInterval: [
				{
					required: true,
					message: "请选择循环单位",
					trigger: "change",
				},
			],
			intervalCount: [
				{
					required: true,
					message: "请输入间隔数",
					trigger: "blur",
				},
			],
		},
	};
}
